import React, { useEffect, useState } from "react";
import "./chapters.scss";
import CourseHeader from "../../../shared/components/AppHeader";
import ChapterForm from "../../../shared/components/CourseComponents/ChapterForm";
import SortableChapterList from "../../../shared/components/CourseComponents/SortableChapterList";
import ChapterActions from "./ChapterActions";
import ChapterService from "../../../services/CourseServices/ChapterService/chapter.service";
import { withRouter } from "react-router-dom";
import EmptyState from "../../../shared/components/EmptyState";
import ChapterContentService from "../../../services/CourseServices/ChapterService/chapterContent.service";
import excerciseService from "../../../services/ExcerciseService/excercise.service";
import { ExerciseModal } from "../../../models/ExerciseModal/Exercise.model";

const Chapters = (props: any) => {
  const { subjectId } = props.match.params;
  const [exercises, setExercises] = useState<any>([]);
  const [contents, setContents] = useState<any>([]);

  useEffect(() => {
    fetchChapters();
  }, []);

  const fetchChapters = (searchString?: string) => {
    let queryParams = `?class_room_subject_id=${subjectId}&search=${searchString || ""
      }`;
    ChapterService.getChaptersList(
      queryParams,
      (chapters: any) => {
        setChaptersList([...chapters]);
        setActiveChapter(chapters.length > 0 ? chapters[0] : "");
      },
      () => { },
      () => { }
    ).then();
  };
  const fetchChapterExerciseList = () => {
    excerciseService.getExcerciseByFilter(
      {
        chaptor_id: activeChapter.id,
      },
      (exercises: ExerciseModal[]) => {
        setExercises(exercises);
      },
      () => { }
    );
  };

  const fetchChapterContentsList = () => {
    ChapterContentService.getChapterContentsList(
      {
        chaptor_id: activeChapter.id,
      },
      (chapterContents: any) => {
        setContents(chapterContents);
      },
      () => { },
      () => { }
    ).then();
  };

  const [chaptersList, setChaptersList] = useState<any>([]);
  const [activeChapter, setActiveChapter] = useState<any>();
  const [formVisible, setFormVisible] = useState<boolean>(false);

  const handleSearch = (value: string) => {
    fetchChapters(value);
  };

  const handleNewBoard = () => {
    setFormVisible(true);
  };

  return (
    <div className="page-view chapters">
      <ChapterForm
        title="Create New Chapter"
        visible={formVisible}
        setVisible={setFormVisible}
        refreshList={fetchChapters}
      />
      <div className="chapter__header">
        <CourseHeader
          headerText="Chapters"
          handleSearch={handleSearch}
          handleHeaderAction={handleNewBoard}
          buttonText="Chapter"
          showBreadCrumb={true}
        />
      </div>
      {chaptersList.length !== 0 ? (
        <>
          <div className="chapter__list">
            <SortableChapterList
              list={chaptersList}
              setList={setChaptersList}
              menuText="Chapter"
              setActiveChapter={setActiveChapter}
              activeChapter={activeChapter}
              refreshList={fetchChapters}
            />
          </div>
          <div className="content__list">
            <ChapterActions
              params={{...props.match.params,chapterId:activeChapter?.id}} // new
              exercises={exercises}
              contents={contents}
              activeChapter={activeChapter}
              fetchChapterContentsList={fetchChapterContentsList}
              fetchChapterExerciseList={fetchChapterExerciseList}
            />

          </div>
        </>
      ) : (
        <EmptyState text={"No chapters found."} />
      )}
    </div>
  );
};

export default withRouter(Chapters);
